// The emails a group's member menu copies to the clipboard
// (PeerGroupMemberActionsMenu.vue).  Joined with ", " so the list pastes into
// an email's To field, and back into a member list's pasted-list box.

import { BaseUser } from '@/models';

/**
 * Each member's primary email, in list order.  Extra addresses are left out
 * so nobody gets the email twice; repeats are dropped regardless of case.
 */
export const rosterEmails = (members: BaseUser[]): string[] => {
  const seen = new Set<string>();

  return members
    .map(m => (m.email || '').trim())
    .filter(email => {
      const key = email.toLowerCase();

      if (!email || seen.has(key)) {
        return false;
      }

      seen.add(key);
      return true;
    });
};

// e.g. "24 Learner emails", or "1 email" with no role.
const emailCount = (count: number, roleName?: string) => {
  const noun = count === 1 ? 'email' : 'emails';
  const role = roleName ? `${roleName} ` : '';

  return `${count} ${role}${noun}`;
};

/**
 * The menu item, which says what it will copy: "Copy all 24 emails" with no
 * role, "Copy 20 Learner emails" with one.
 */
export const copyEmailsLabel = (count: number, roleName?: string) => {
  if (count === 0) {
    return 'No emails to copy';
  }

  const all = !roleName && count > 1 ? 'all ' : '';

  return `Copy ${all}${emailCount(count, roleName)}`;
};

/** e.g. "Copied 24 Learner emails", or "Copied 1 email" with no role. */
export const copiedEmailsMessage = (count: number, roleName?: string) =>
  `Copied ${emailCount(count, roleName)}`;
